module.exports = __webpack_public_path__ + "static/educator-97d450e17006ec8283f3dd3ac07c747f.jpg";